import { compose, bindActionCreators  } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import dataFetcher from "../../parts/chore/dataFetcher";
import { searchDrafts, clearSearch } from '../../search/searchActions';
import { updateMessage, getMessage } from '../../messages/messageActions';
import { Form } from 'antd';

import SavedDrafts from './SavedDrafts';

const mapStateToProps = state => ({
    member: state.member.member,
    drafts: state.search.drafts ? state.search.drafts.results : [],
    pagination: state.search.drafts ? state.search.drafts.pagination : [],
    fetchTime: state.search.drafts ? state.search.drafts.fetchTime : [],
    locale: state.session.language,
    search: state.search.messages.search,
    session: state.session,
    isSendMessageInProgress: state.message.isSendMessageInProgress,
    accentColors: state.platform.platform.settings.color,
    message: state.message.message,
    canSendEmails: state.message.canSendEmails,
    platformId: state.platform.platform.id
});

const mapDispatchToProps = dispatch => bindActionCreators({
  searchDrafts,
  clearSearch,
  updateMessage,
  getMessage
 }, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  Form.create(),
  dataFetcher
)(SavedDrafts);